import { Crown } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { useLanguage } from "@/components/LanguageContext";

interface PremiumBadgeProps {
  className?: string;
}

export function PremiumBadge({ className }: PremiumBadgeProps) {
  const { language } = useLanguage();
  
  return (
    <Badge 
      variant="warning" 
      className={cn(
        "flex items-center justify-center p-1 bg-gradient-to-r from-amber-500 to-amber-400 text-white", 
        className
      )}
    >
      <Crown className="h-3.5 w-3.5" />
    </Badge>
  );
}
